












import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'

export default Vue.extend({
  name: 'PasswordComplete',
  components: {
    PageTitle,
    ButtonWrap,
    RoundButton
  },
  methods: {
    onClick() {
      this.$router.push('/signin')
    }
  }
})
